import AsyncHelper from "../helpers/AsyncHelper";
import {Swiper, Navigation, SwiperOptions, Pagination, Autoplay} from "swiper";
import {DEFAULT_TIMEOUT_TIME} from "../constans";

Swiper.use([Navigation, Pagination,Autoplay]);

/**
 * Обычный слайдер, основанный на плагине swiper
 */
export default class Slider {
    private readonly TIMEOUT_TIME = DEFAULT_TIMEOUT_TIME;
    private readonly START_ANIMATION_CLASS = 'start';
    private readonly HIDE_CLASS = 'hide';

    private readonly $holder: JQuery;
    public swiper: Swiper|null = null;
    public thumbSwiper: Swiper | null = null;
    private defaultConfig: SwiperOptions = {
        slidesPerView: 'auto',
    };
    private readonly config: SwiperOptions = this.defaultConfig;
    private withThumb = false;

    private selectors = {
        slide: '.js-slider-item',
        circleAnimation: '.js-slider-circle-animation-button',
        swipeIcon: '.js-icon-swipe',
        swiperBlock: '.js-icon-swipe-wrapper',
        thumbSwiper: '.js-thumb-slider'
    };

    constructor($holder: JQuery, settings: SwiperOptions = null, withThumbSwiper = false) {
        this.$holder = $holder;

        if (this.$holder.find(this.selectors.slide).length <= 1) {
            this.$holder.addClass('no-slide');
        }

        this.config = $.extend(this.defaultConfig, this.$holder.data('config') as SwiperOptions, settings ?? {});
        this.withThumb = withThumbSwiper;
        this.resizeHandler = this.resizeHandler.bind(this);
        this.hideSwipeIconBySlider = this.hideSwipeIconBySlider.bind(this);
        this.initEvents();
        this.init();
    }

    /**
     * Инициализация
     * @private
     */
    private init(): void
    {
        const nativeHolder = this.$holder.find('.swiper').get(0);
        const $buttonNext = this.$holder.find('.js-slider-button.next');
        const $buttonPrev = this.$holder.find('.js-slider-button.prev');
        const $pagination = this.$holder.find('.js-pagination');

        if (!nativeHolder) {
            return;
        }

          // Клонируем конфиг что бы не мутировать оригинал
        const config: SwiperOptions = $.extend({}, this.config);

        config.navigation = {
            nextEl: $buttonNext.get(0),
            prevEl: $buttonPrev.get(0)
        };
        config.pagination = {
            el: $pagination.get(0),
            type: 'bullets',
            // formatFractionCurrent: (number: number) => Number(`0${number}`),
            // formatFractionTotal: (number: number) => Number(`0${number}`),
            // renderFraction: function (currentClass, totalClass) {
            //     return '<span class="number text-green ' + currentClass + '"></span>' +
            //         ' <span class="slider__separator h5">/</span> ' +
            //         '<span class="h5 ' + totalClass + '"></span>';
            // }
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + "</span>";
            },
        };
        if (this.withThumb) {
            this.thumbSwiper = new Swiper($(this.selectors.thumbSwiper).find('.swiper').get(0), {
                slidesPerView: 1,
                allowTouchMove: false,
            })
            config.thumbs = {
                swiper: this.thumbSwiper,
            }
        }
        this.swiper = new Swiper(nativeHolder, config);
        if  (
            this.$holder.find('.js-slider-button.next').hasClass('swiper-button-disabled') &&
            this.$holder.find('.js-slider-button.prev').hasClass('swiper-button-disabled')
        ) {
            this.$holder.addClass('no-slide');
        }

        this.swiper.on('slideChange', (swiper: Swiper) => {
            this.$holder.find(this.selectors.circleAnimation)
                .removeClass(this.START_ANIMATION_CLASS)
            if (this.withThumb) {
                this.thumbSwiper.slideTo(swiper.activeIndex);
            }
            //запускаем анимацию заново
            setTimeout(() => {
                this.$holder.find(this.selectors.circleAnimation)
                    .addClass(this.START_ANIMATION_CLASS);
            }, 10);
            this.hideSwipeIconBySlider();
        });

        if (this.withThumb) {
            this.$holder.find(this.selectors.slide).each((index, element) => {
                const $slide = $(element);
                $slide.on('click', () => {
                    this.swiper.slideTo(index);
                })
            })
        }
    }


    private resizeHandler():void
    {
        if (!this.swiper) {
            return this.init();
        }

        this.swiper.destroy();
        this.init();
    }

    /**
     * Иницализация событий
     * @private
     */
    private initEvents(): void
    {

        const resizeHandlerWithDebounce = AsyncHelper.debounce(
            this.resizeHandler,
            this.TIMEOUT_TIME
        );

        $(document).on('resize', () => {
            void resizeHandlerWithDebounce();
        });
    }

    /**
     * Скрыть иконку свайпа
     * @private
     */
    private hideSwipeIconBySlider(): void {
        this.$holder
            .closest(this.selectors.swiperBlock)
            .find(this.selectors.swipeIcon)
            .addClass(this.HIDE_CLASS);
    }
}
